<div class="segmentation-protocol-cell" (click)="$event.stopPropagation()">
  <mat-radio-button
    [disabled]="!canEdit"
    [checked]="checked"
    (click)="onSelectClick()"
    [attr.data-cy]="'button-select-model-' + optionCySuffix()"
  >
    {{ label.name }}
  </mat-radio-button>
  <span class="segmentation-protocol-cell__actions">
    <button
      mat-icon-button
      class="segmentation-protocol-cell__pin-btn"
      (click)="onPinClick($event)"
      aria-label="Toggle pin"
      [matTooltip]="'tooltip.pin_unpin_model' | translate"
      [matTooltipShowDelay]="1000"
    >
      <i
        [ngClass]="{
          'ri-pushpin-fill': pinned,
          'ri-pushpin-line': !pinned,
          'color-accent': pinned
        }"
      ></i>
    </button>
  </span>
  <span
    class="segmentation-protocol-cell__badge"
    [style.background-color]="label.color"
    [attr.data-cy]="'badge-segm-class-' + optionCySuffix()"
  ></span>
</div>
